/**
 * Created by Owner on 2016/8/9.
 */
import {Component} from '@angular/core';
import {AlertController, NavParams, NavController, LoadingController} from 'ionic-angular';
import {AppConfigService} from "../../services/appConfig.service";
import {UserService} from "../../services/user.services";
import {AppDialog} from "../../component/appDialog";
import {PersonBankCardAddPage} from "../personBankCardAdd/personBankCardAdd";

@Component({
    templateUrl: 'personBankCardConfirm.html',
    selector: 'agency-user-deposit-page',
})
export class PersonBankCardConfirmPage {
    data: any;
    nbankcard: any;

    constructor(private navParams: NavParams, private nav: NavController, private loadingCtrl: LoadingController, private alertCtrl: AlertController, private userService: UserService) {
        this.data = navParams.get("data");
        let nbankcardstr = this.data.nbankcard.toString();
        if (nbankcardstr.length == 16) {
            let list = [nbankcardstr.substr(0, 4), nbankcardstr.substr(4, 4), nbankcardstr.substr(8, 4), nbankcardstr.substr(12, 4)];
            this.nbankcard = list.join("  ");
        } else {
            let list = [nbankcardstr.substr(0, 4), nbankcardstr.substr(4, 4), nbankcardstr.substr(8, 4), nbankcardstr.substr(12, 4), nbankcardstr.substr(16, 3)];
            this.nbankcard = list.join("  ");
        }

    }

    submitFn() {
        this.userService.addBankcardCheckAdd({}, this).then(data => {
            if (!data["msg"]) {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: "Thêm Tài khoản ngân hàng thành công."
                });
                PersonBankCardAddPage.NeedInit = true;
                this.nav.pop();
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/personBankCardConfirm/personBankCardConfirm.ts